import type { Assessment } from '@brighterly/lib-core-types/assessment/interfaces'
import type { AssessmentsStore } from './interfaces'

import { useDisciplineStore } from '@stores/discipline'

import { isFullArray } from '@helpers/array'

const getLastAssessment = (state: AssessmentsStore): Assessment | null => {
  return state.assessments?.[state.assessments.length - 1] || null
}

const getLinkUpsell = (state: AssessmentsStore): string | null => {
  const disciplineStore = useDisciplineStore()
  return disciplineStore.isReversedEla
    ? state.linkUpsellEla
    : disciplineStore.isReversedMath
      ? state.linkUpsellMath
      : null
}

export const getters = {
  isAssessments: (state: AssessmentsStore): boolean => isFullArray(state.assessments),
  getAssessments: (state: AssessmentsStore): AssessmentsStore['assessments'] => state.assessments,
  getLastAssessment: (state: AssessmentsStore): Assessment | null => getLastAssessment(state),
  isLastAssessmentCompleted: (state: AssessmentsStore): boolean => {
    const lastAssessment = getLastAssessment(state)
    return !!lastAssessment?.show_url
  },
  getLastAssessmentResultUrl: (state: AssessmentsStore): string | null => {
    const lastAssessment = getLastAssessment(state)
    return lastAssessment?.show_url || null
  },
  getAssessmentAutologinUrl: (state: AssessmentsStore): AssessmentsStore['assessmentAutologinUrl'] => state.assessmentAutologinUrl,
  getAssessmentAutologinSharedUrl: (state: AssessmentsStore): AssessmentsStore['assessmentAutologinSharedUrl'] => state.assessmentAutologinSharedUrl,
  hasLastAssessment: (state: AssessmentsStore): boolean => {
    if (!state.assessmentAutologinUrl) {
      return !!getLastAssessment(state)
    } else {
      return true
    }
  },
  getLinkUpsellMath: (state: AssessmentsStore): AssessmentsStore['linkUpsellMath'] => state.linkUpsellMath,
  getLinkUpsellEla: (state: AssessmentsStore): AssessmentsStore['linkUpsellEla'] => state.linkUpsellEla,
  getLinkUpsell: (state: AssessmentsStore): string | null => getLinkUpsell(state),
  isLinkUpsell: (state: AssessmentsStore): boolean => !!getLinkUpsell(state),
  isAssessmentUpsellClosed: (state: AssessmentsStore): AssessmentsStore['assessmentUpsellClosed'] => state.assessmentUpsellClosed,
}
